<template>
    <div class="records-time-line">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">Registros</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl pa-0>
                                <v-layout wrap>
                                    <v-flex sm4>
                                        <v-treeview
                                            :active.sync="selectedObject"
                                            :items="items"
                                            activatable
                                            active-class="primary--text"
                                            class="grey lighten-5"
                                            transition
                                            return-object
                                            hoverable
                                        >
                                        </v-treeview>
                                    </v-flex>

                                    <v-flex sm8>
                                        <v-card-text class="pa-0">
                                            <v-container fluid grid-list-xl pa-0>
                                                <v-layout wrap>
                                                    <v-flex xs12 class="load-options-section" style="width: 63%">
                                                        <v-layout wrap>
                                                            <template v-if="selectedSeccion">
                                                                <v-flex tag="strong" sm1 text-xs-right>Módulo:</v-flex>
                                                                <v-flex sm1>{{ selectedModulo }}</v-flex>
                                                                <v-flex tag="strong" sm1 ml-4 text-xs-right
                                                                    >Sección:</v-flex
                                                                >
                                                                <v-flex sm3>{{ selectedSeccion }}</v-flex>
                                                            </template>
                                                            <v-flex v-else tag="strong"
                                                                >Seleccione una sección para ver sus opciones</v-flex
                                                            >
                                                            <v-btn
                                                                small
                                                                color="primary"
                                                                class="ml-3"
                                                                v-if="selectedSeccion"
                                                                :loading="loading"
                                                                :disabled="historyElement === selectedObject[0].name"
                                                                @click="fetchData"
                                                                >Cargar opciones</v-btn
                                                            >
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex sm12 class="py-1 pt-5 px-0">
                                                        <v-data-table
                                                            v-if="elementos.length"
                                                            :headers="headers"
                                                            :loading="loadingHistory"
                                                            :items="elementos"
                                                            class="elevation-1"
                                                            item-key="id"
                                                        >
                                                            <v-progress-linear
                                                                v-slot:progress
                                                                color="green"
                                                                indeterminate
                                                            ></v-progress-linear>
                                                            <template slot="items" slot-scope="props">
                                                                <tr>
                                                                    <td>
                                                                        {{ getNameValue(props.item) }}
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                            props.item.status_description
                                                                                ? props.item.status_description
                                                                                : "-"
                                                                        }}
                                                                    </td>
                                                                    <td class="pl-0">
                                                                        <v-layout class="justify-end">
                                                                            <div style="width: 52px">
                                                                                <v-fade-transition>
                                                                                    <div>
                                                                                        <v-tooltip bottom>
                                                                                            <template
                                                                                                v-slot:activator="{
                                                                                                    on
                                                                                                }"
                                                                                            >
                                                                                                <v-btn
                                                                                                    flat
                                                                                                    icon
                                                                                                    color="grey"
                                                                                                >
                                                                                                    <v-icon
                                                                                                        medium
                                                                                                        v-on="on"
                                                                                                        @click="
                                                                                                            loadHistory(
                                                                                                                props.item
                                                                                                            )
                                                                                                        "
                                                                                                        >fa-archive</v-icon
                                                                                                    >
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Ver historial</span>
                                                                                        </v-tooltip>
                                                                                    </div>
                                                                                </v-fade-transition>
                                                                            </div>
                                                                        </v-layout>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template slot="no-data">
                                                                <div style="text-align: center">
                                                                    No existen elementos del tipo requerido.
                                                                </div>
                                                            </template>
                                                        </v-data-table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <time-line
            v-if="showHistory"
            :data="dataHistory"
            :element="historyElement"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
const TimeLine = () => import("@/components/widgets/records-time-line/time-line")
import Util from "@/util"

export default {
    components: { TimeLine },
    props: {},
    data() {
        return {
            loading: false,

            //treeview
            selectedObject: [],
            items: Util.RecordsSelect(),
            scrollSettings: {
                maxScrollbarLength: 160
            },

            //opciones cargadas del back para la seccion seleccionada
            elementos: [],

            //tabla
            headers: [
                { text: "Nombre", value: "nombre" },
                { text: "Estado", value: "status_description" },
                { sortable: false }
            ],

            //history
            loadingHistory: false,
            showHistory: false,
            dataHistory: null,
            historyElement: null,
            historyClassName: null
        }
    },
    computed: {
        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        selectedModulo() {
            if (this.selectedObject.length) {
                if (this.selectedObject[0].children.length) {
                    return this.selectedObject[0].name
                } else {
                    let moduloName = ""
                    this.items.forEach(modulo => {
                        const subItem = modulo.children.filter(el => el.name === this.selectedObject[0].name)
                        if (subItem.length) {
                            moduloName = modulo.name
                        }
                    })
                    return moduloName
                }
            }
        },

        selectedSeccion() {
            if (this.selectedObject.length) {
                if (!this.selectedObject[0].children.length) {
                    return this.selectedObject[0].name
                } else return null
            }
        }
    },

    methods: {
        cancelForm() {
            this.$emit("formCanceled")
        },

        fetchData() {
            this.loading = true
            this.$store.dispatch(this.selectedObject[0].dispatchRecords).then(() => {
                this.elementos = this.$store.getters[this.selectedObject[0].getter]
                this.historyElement = this.selectedObject[0].name
                this.historyClassName = this.selectedObject[0].historyClassName
                this.loading = false
            })
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName(this.historyClassName)
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.dataHistory = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        getNameValue(item) {
            if (item.username) {
                return item.username
            } else if (item.letra) {
                return item.letra
            } else if (item.apellido_paterno) {
                return item.nombre + " " + item.apellido_paterno + " " + item.apellido_materno
            } else if (item.nombre_solicitante) {
                return item.nombre_solicitante
            } else if (item.codigo) {
                return item.codigo
            } else if (item.nombre) {
                return item.nombre
            } else if (item.descripcion) {
                return item.descripcion
            } else if (item.razon_o_nombre) {
                return item.razon_o_nombre
            } else return "-"
        }
    },

    created() {}
}
</script>

<style scoped>
.load-options-section {
    position: fixed;
    background-color: rgba(179, 212, 252, 0.6);
}

.load-options-section:hover {
    background-color: rgb(179, 212, 252);
}
</style>
